// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__duz5Q","dragIcon":"Choice_dragIcon__1RKIz","left":"Choice_left__2kyKn","input":"Choice_input__2Q7y5"};